import React from "react";

export function DeleteButton({ onClick }: { onClick: () => void }) {
  return <button onClick={onClick}>🗑️</button>;
}
